import React from 'react';
import PropTypes from 'prop-types';

function SearchResults({ search, render, header, className = '' }) {
  return (
    <div className={`circle-search-results ${className}`}>
      {!!search.circles.length && (
        <>
          {header}
          {search.circles.map(render)}
        </>
      )}
      {search.loading && <p role='status'>{search.circles.length ? 'Loading more Circles…' : 'Searching Circles…'}</p>}
      {search.error && (
        <p role='alert'>
          {search.error} {search.retry && <button onClick={search.retry}>Retry search</button>}
        </p>
      )}
      {!search.loading && !search.error && !search.circles.length && <p>No Circles found.</p>}
    </div>
  );
}

SearchResults.propTypes = {
  search: PropTypes.shape({ loading: PropTypes.bool, error: PropTypes.string, circles: PropTypes.array.isRequired, retry: PropTypes.func })
    .isRequired,
  render: PropTypes.func.isRequired,
  header: PropTypes.node,
  className: PropTypes.string
};

export default SearchResults;
